const BuyersInfo = () => import('../../../components/Buyers/Buyer/BuyerInfo.vue')

export default [{
  name: 'BuyersInfo',
  path: ':buyerId',
  component: BuyersInfo,
  meta: {requiresAuth: true}
}, {
    name: 'BuyersInfo',
    path: ':buyerId/:isBuyer',
    component: BuyersInfo,
    meta: {requiresAuth: true}
}]



// WEBPACK FOOTER //
// ./src/router/home/buyers/index.js